import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=6dbb04e8&"
import script from "./ToggleSwitch.js?vue&type=script&lang=js&"
export * from "./ToggleSwitch.js?vue&type=script&lang=js&"
import style0 from "./ToggleSwitch.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports